module.exports = new __parcel__URL__("common_asteroid.3caa2676.png").toString();